import React from "react"
import PropTypes from "prop-types"
import {Box, Grid, Stack, Typography} from "@mui/material"
import {validationResultGroupsPropType} from "./validation-results-model"

const ResultMetric = ({label, value}) => (
    <Box
        component="div"
        sx={{
            alignItems: "baseline",
            columnGap: 0.5,
            display: "flex",
            flexWrap: "wrap",
            minWidth: 0,
            rowGap: 0.25,
        }}
    >
        <Typography
            component="dt"
            variant="textBody"
            sx={{color: "common.white", fontWeight: "bold", whiteSpace: "nowrap"}}
        >
            {`${label}:`}
        </Typography>
        <Typography
            component="dd"
            variant="textBody"
            sx={{m: 0, color: "common.white", overflowWrap: "anywhere"}}
        >
            {value}
        </Typography>
    </Box>
)

const ValidationResultsLayout = ({groups}) => (
    <Grid container spacing={0.25} aria-label="Métricas da validação">
        {groups.map((group) => (
            <Grid key={group.id} item {...group.gridProps} sx={{display: "flex", minWidth: 0}}>
                <Box
                    component="dl"
                    aria-label={`Resultados ${group.id}`}
                    sx={{
                        bgcolor: "input.background.white05",
                        boxSizing: "border-box",
                        height: "100%",
                        m: 0,
                        minWidth: 0,
                        p: 2,
                        width: "100%",
                    }}
                    >
                    <Stack spacing={0.75}>
                        {group.items.map((item) => (
                            <ResultMetric key={item.id} {...item}/>
                        ))}
                    </Stack>
                </Box>
            </Grid>
        ))}
    </Grid>
)

ResultMetric.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
}

ValidationResultsLayout.propTypes = {
    groups: validationResultGroupsPropType.isRequired,
}

export default ValidationResultsLayout
